import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Umbrella01 = function Umbrella01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M17 19.4c0 1.4359-1.1193 2.6-2.5 2.6S12 20.8359 12 19.4V12m-9.8737-1.5937C2.8895 5.6409 7.0195 2 12 2s9.1104 3.641 9.8737 8.4063c.0745.4651.1117.6976.0182.946-.0744.1977-.2566.4113-.44.5161C21.2214 12 20.9476 12 20.4 12H3.6c-.5477 0-.8215 0-1.052-.1316-.1834-.1048-.3655-.3184-.44-.5161-.0935-.2484-.0562-.4809.0183-.946"
    })
  }));
};
export default Umbrella01;